<ng-container *ngIf="loading">
    <div class="container-with-loading">
        <div class="loading-overlay">
            <mat-spinner></mat-spinner>
        </div>
    </div>
</ng-container>
  
<mat-card class="offer-card" appearance="outlined" [hidden]="loading">
    <!--mat-card-header>
        <mat-card-title>Area</mat-card-title>
	</mat-card-header-->
	<mat-card-content>

		<form class="form-container" (ngSubmit)="onSubmitDivision(benefitGroupForm)" #benefitGroupForm="ngForm" >

			<mat-card class="general-wf-card" appearance="outlined">
				<mat-card-header>
					<mat-card-title>{{title}}</mat-card-title>
				</mat-card-header>
				<mat-card-content>
					<div id="container" class="formControl">

						<div class="control">
							<mat-form-field class="controlWidth">
								<mat-label>C&oacute;digo</mat-label>
								<input type="text" matInput name="division.code" [(ngModel)]="division.code">
								<mat-error>{{ violations['division.code'] }}</mat-error>
							</mat-form-field>
						</div>
						<div class="control">
							<mat-form-field class="controlWidth">
								<mat-label>Descripci&oacute;n</mat-label>
								<input type="text" matInput name="division.description" [(ngModel)]="division.description">
								<mat-error>{{ violations['division.description'] }}</mat-error>
							</mat-form-field>
						</div>
						<div class="control">
							<mat-slide-toggle [(ngModel)]="division.active"  name="divisionActive" > 
							  {{ division.active? 'Division Activa':'Division Inactiva'}} 
							</mat-slide-toggle>
						</div>

					</div>
				</mat-card-content>
			</mat-card>
			<div class="formControl">
				<div class="control">
					<button mat-flat-button class="button buttonWidth">
					  {{(division.id > 0)? 'Actualizar': 'Guardar'}}
					</button>
				</div>
			</div>
		</form>
	</mat-card-content>
</mat-card>